// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyChatView_root__Rn8Mx"};